import { frontendURL } from '../../../helper/URLHelper';
import CompaniesIndex from './pages/CompaniesIndex.vue';
import CompanyDetailView from './pages/CompanyDetailView.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';

// M29.5.18B — 'agent' used to be listed here, but every non-admin NEXCEO
// user (Team Leader or Agent) carries Chatwoot's base 'agent' role, so it
// made this permission check trivially true for everyone — the standalone,
// account-wide Companies workspace must be admin-only, matching
// Nexceo::AccessPolicy's lack of any account-wide Companies scope for
// non-admins (there's no company-level custom-role permission to preserve,
// unlike Contacts' 'contact_manage'). See Sidebar.vue's matching admin-only
// gate on the 'Companies' entry.
const commonMeta = {
  featureFlag: FEATURE_FLAGS.COMPANIES,
  permissions: ['administrator'],
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/companies'),
    component: CompaniesIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'companies_dashboard_index',
        component: CompaniesIndex,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/companies/:companyId'),
    component: CompanyDetailView,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'companies_dashboard_show',
        component: CompanyDetailView,
        meta: commonMeta,
      },
    ],
  },
];
